import { createAction, props } from "@ngrx/store";
export const applicationsSearch = createAction('[tab-applications] ApplicationsSearch', props());
export const applicationsSearchType = createAction('[tab-applications] ApplicationsSearchType', props());
export const applicationsFormGroup = createAction('[tab-applications] ApplicationsFormGroup', props());
export const applicationsTabChanged = createAction('[tab-applications] ApplicationsTabChanged', props());
